var _a;
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { Url } from '@wix/da-url';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showSubmitModal } from '../Modals/redux/actionCreators';
import { ModalType } from '../Modals/redux/types';
import { useRestrictToLoggedIn } from '../utils/hooks/useRestrictToLoggedIn';
import { useVerification } from '../VerificationPopup/withVerification';
var modalTypesForLinking = (_a = {},
    _a[ModalType.STATUS_UPDATE] = 'status',
    _a[ModalType.JOURNAL] = 'journal',
    _a[ModalType.LITERATURE] = 'literature',
    _a[ModalType.POLL_EDIT] = 'poll',
    _a[ModalType.WIX_PORTFOLIO_CREATE] = 'portfolio',
    _a[ModalType.TIER_EDIT] = 'tier',
    _a);
function getBiData(type, href) {
    if (href) {
        return BiData({
            evid: 702,
            menu_item: type,
            menu_name: 'submit',
            link_url: href,
        });
    }
    return BiData({
        evid: 702,
        menu_item: type,
        menu_name: 'submit',
    });
}
/** handles stuff like verification, loggedout, legacy header for submit menu items */
export function useSubmitMenuItem(_a) {
    var modalType = _a.modalType, link = _a.link, verificationAction = _a.verificationAction, type = _a.type, modalOptions = _a.modalOptions, isLegacyHeader = _a.isLegacyHeader;
    var _b = useVerification(), isVerificationNeeded = _b.isVerificationNeeded, pushVerificationPopup = _b.pushVerificationPopup;
    var _c = useRestrictToLoggedIn(), isLoggedIn = _c.isLoggedIn, sendUserToJoinPage = _c.sendUserToJoinPage;
    var dispatch = useDispatch();
    var menuItem = useMemo(function () {
        var linkTo = modalType
            ? "".concat(Url.browseHomeLink(), "?submit_modal=").concat(modalTypesForLinking[modalType])
            : link;
        // if user is not logged in, send them to fix that
        if (!isLoggedIn) {
            return {
                onClick: function () { return sendUserToJoinPage(ReferralType.SUBMIT); },
            };
        }
        // if not verified, show appropriate modal
        // except on legacy header which cannot do modals, but thats okay because
        // it will get redirected to some page that handles it anyway
        if (isVerificationNeeded && !isLegacyHeader) {
            return {
                onClick: function () { return pushVerificationPopup(verificationAction); },
            };
        }
        // modal-type submits
        if (modalType) {
            // legacy does not do modals, so redirect to home and show it there
            return isLegacyHeader
                ? {
                    href: linkTo,
                    biData: getBiData(type, linkTo),
                }
                : {
                    onClick: function () { return dispatch(showSubmitModal(modalType, modalOptions)); },
                    biData: getBiData(type),
                };
        }
        // everything else goes brrr
        return { href: linkTo, biData: getBiData(type, linkTo) };
    }, [
        dispatch,
        isLegacyHeader,
        isLoggedIn,
        isVerificationNeeded,
        link,
        modalOptions,
        modalType,
        pushVerificationPopup,
        sendUserToJoinPage,
        type,
        verificationAction,
    ]);
    return menuItem;
}
//# sourceMappingURL=useSubmitMenuItem.js.map